module.exports = __webpack_public_path__ + "static/media/tresio_logo.a6520a91.svg";